import { useMediaQuery } from "./media-query/MediaHook";

export const useIsSmall = () => useMediaQuery("(max-width: 480px)");
export const useIsMedium = () => useMediaQuery("(max-width: 768px)");
